<div class="dialog__header">
    <h2 mat-dialog-title>Claims JSON Validator</h2>
    <button class="dialog__close-button"
            mat-dialog-close
            mat-icon-button
            tabindex="-1">
        <mat-icon>close</mat-icon>
    </button>
</div>

<div class="dialog__content">
    <div class="content">
        <form [formGroup]="formGroup" (ngSubmit)="validateClaimsJson($event)">
            <div class="data">
                <mat-form-field class="textarea-field" floatLabel="always">
                    <mat-label>Claims JSON</mat-label>
                    <textarea matInput
                              required
                              placeholder="https://apiint-dev.parcelpro.com/api/claims/details?trackingNumber=1Z8746387638749"
                              [formControl]="formGroup?.controls.json"
                              rows="20"></textarea>
                </mat-form-field>
                <mat-form-field class="textarea-field" floatLabel="always">
                    <mat-label>Shipment JSON</mat-label>
                    <textarea matInput
                              required
                              placeholder="https://apiint-dev.parcelpro.com/api/claims/shipments?trackingNumber=1Z8746387638749"
                              [formControl]="formGroup?.controls.shipment"
                              rows="20"></textarea>
                </mat-form-field>
                <mat-form-field class="textarea-field" floatLabel="always">
                    <mat-label>User Contacts JSON</mat-label>
                    <textarea matInput
                              required
                              placeholder="https://apiint-dev.parcelpro.com/api/contacts/ap?Except1row=false"
                              [formControl]="formGroup?.controls.contacts"
                              rows="20"></textarea>
                </mat-form-field>
            </div>

            <button mat-flat-button
                    [disabled]="!formGroup.valid"
                    class="dialog__action dialog__action--yes"
                    color="primary"
                    type="submit">
                <span class="button__content">Validate</span>
            </button>

            <div class="results">
                @if (resultClaim) {
                    <div class="json">
                        <pre>{{ resultClaim | json }}</pre>
                    </div>
                }

                @if (showErrors) {
                    <div class="errors">
                        <upsc-form-errors [control]="claimForm"></upsc-form-errors>
                    </div>
                }
            </div>
        </form>
    </div>
</div>
